import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { Menubar } from 'primereact/menubar';
import { TieredMenu } from 'primereact/tieredmenu';
import React, { useContext, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { VendersContext } from './../../context/Store';
import './Navber.scss';


function Navber() {
  let { LogOut, isOpen, setIsOpen, isLang, setIsLang, Profile } = useContext(VendersContext);
 

  const handleActionSelect = async (action) => {
    if (action === 'en') {
      setIsLang('en')
    } else if (action === 'ar') {
      setIsLang('ar')
    }
  }
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  const onAvatarClick = (event) => {
    menuRef.current.show(event);
    setShowMenu(!showMenu);
  };
  const items = [
    {
      label: isLang === 'en' ? 'Change Lang' : 'تغير اللغة',
      icon: 'pi pi-fw pi-globe ',
      items: [
        {
          label: 'عربيه',
          icon: isLang === 'ar' ? 'pi pi-fw  pi-check' : ' ',
          command: () => handleActionSelect('ar'),

        },
        {
          label: 'English',
          icon: isLang === 'en' ? 'pi pi-fw  pi-check' : ' ',
          command: () => handleActionSelect('en'),

        },
      ]
    },
  ];

  const start = <Button  rounded style={{width:'35px',height:'35px'}} outlined text raised   className='mr-2 ml-2' onClick={() => setIsOpen(!isOpen)} icon="pi pi-bars"size='small'  />  
  const end = <Avatar onClick={onAvatarClick} label={Profile?.name?.charAt(0)?.toUpperCase()} size="mediam" style={{ backgroundColor: '#1A4DA6', color: '#ffffff' }} />

  const menuItems = [

    {
      label: <Link to="/profile"> {isLang === 'en' ? 'Profile' : 'الملف الشخصي'}</Link>,

      icon: 'pi pi-fw pi-user',
      command: () => {
        // LogOut();

      },
    },

    {
      label: <Link to="/admin/login"> {isLang === 'en' ? 'Logout' : 'تسجيل خروج  '}</Link>,
      icon: 'pi pi-fw pi-sign-out',
      command: () => {
        LogOut();
      },

    },
    {
      label: isLang === 'en' ? 'Change Lang' : 'تغير اللغة',
      icon: 'pi pi-fw pi-globe ',
      items: [
        {
          label: 'عربيه',
          icon: isLang === 'ar' ? 'pi pi-fw  pi-check' : ' ',
          command: () => handleActionSelect('ar'),

        },
        {
          label: 'English',
          icon: isLang === 'en' ? 'pi pi-fw  pi-check' : ' ',
          command: () => handleActionSelect('en'),

        },
      ]
    },
    { separator: true },
    {
      template: (item, options) => {
        return (
          <button onClick={(e) => options.onClick(e)} className={'w-full p-link flex align-items-center px-3 pb-3 pt-3'}>
            <Avatar image={Profile?.image} className="mr-2" shape="circle" />
            <div className="flex flex-column align">
              <span className="font-bold">{Profile?.name}</span>
              <span className="text-sm">{Profile?.email}</span>
            </div>
          </button>
        )
      }

    },
  ];
  return (
    <div className="card navbar-primereact w-full" dir={isLang == "en" ? 'ltr' : 'rtl'}>

      <Menubar model={items} end={<div className="p-menu-list	">{end}</div>} start={start} />

      <TieredMenu
        ref={menuRef}
        model={menuItems}
        popup
        onHide={() => setShowMenu(false)}
        id="popup_menu"
        style={{ display: showMenu ? 'block' : 'none' }}
        className='mt-2'
      />
    </div>
  )

}

export default Navber